<template>
    <div>
<!--body content start-->


<!--body content start-->

<div id="main-page" class="page-content">

<!--blog start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
        <div class="post mt-5">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
        <div class="post mt-5">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
        <nav aria-label="Page navigation" class="mt-5">
          <ul class="pagination">
            <li class="page-item"><a class="page-link" href="#"><i class="fas fa-arrow-right"></i></a>
            </li>
            <li class="page-item active"><a class="page-link" href="#">1</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">2</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">3</a>
            </li>
            <li class="page-item"><a class="page-link" href="#"><i class="fas fa-arrow-left"></i></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-lg-4 col-md-12 sidebar md-mt-5">
        <div class="widget">
          <div class="widget-search">
            <form class="form-inline form">
              <div class="widget-searchbox">
                <button type="submit" class="search-btn"> <i class="fas fa-search"></i>
                </button>
                <input type="text" placeholder="Search Here..." class="form-control">
              </div>
            </form>
          </div>
        </div>
        <div class="widget">
          <h4 class="widget-title">Categories</h4>
          <ul class="widget-categories list-unstyled">
            <li> <a href="#">Design</a>  <small>(8)</small>
            </li>
            <li> <a href="#">Travel News</a>  <small>(5)</small>
            </li>
            <li> <a href="#">Creative Strategies</a>  <small>(7)</small>
            </li>
            <li> <a href="#">Modern Technology</a>  <small>(3)</small>
            </li>
            <li> <a href="#">Product</a>  <small>(4)</small>
            </li>
            <li> <a href="#">Web Hosting </a>  <small>(6)</small>
            </li>           
            <li> <a href="#">Portfolio</a>  <small>(9)</small>
            </li>
          </ul>
        </div>
        <div class="widget">
          <h4 class="widget-title">Latest News</h4>
          <div class="recent-post">
            <ul class="list-unstyled">
              <li>
                <div class="recent-post-desc">
                  <a href="blog-single.html">We Develop Digital Strategy</a> 
                </div>
              </li>
              <li>
                <div class="recent-post-desc">
                  <a href="blog-single.html">These guide Designing work</a> 
                </div>
              </li>
              <li>
                <div class="recent-post-desc">
                  <a href="blog-single.html">We're Nominated To Agency</a> 
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="widget">
          <h4 class="widget-title">Tag Clouds</h4>
          <ul class="widget-tags list-inline">
            <li> <a href="#">Agency</a>
            </li>
            <li> <a href="#">Portfolio</a>
            </li>
            <li> <a href="#">Creative</a>
            </li>
            <li> <a href="#">HTML5</a>
            </li>
            <li> <a href="#">Modern</a>
            </li>
            <li> <a href="#">Design</a>
            </li>
          </ul>
        </div>
        <div class="widget">
          <h4 class="widget-title">Archives</h4>
          <ul class="widget-categories list-unstyled">
            <li> <a href="#">September 2019</a>
            </li>
            <li> <a href="#">October 2019</a>
            </li>
            <li> <a href="#">November 2019</a>
            </li>
          </ul>
        </div>  
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>

export default {
    data: function () {
        return {
            name: 'blog right sidebar'
        }
    },
};
</script>
